import React from "react";
import { useTranslation } from "react-i18next";
import { Mask_Dashboard } from "../../assets/images";
import UserInitials from "../UserInitials";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const DashboardHeader = ({
  usersInitials,
  welcomBackHeading,
  onClick,
  isFinanceDetail = false,
  isProgressBar = false,
  loanAmountText,
  loanLabelText,
  totalLoan,
  loanUtilization,
}) => {
  const { t } = useTranslation();
  const { tenantConfig } = useApp();

  const progressPercentage = (loanUtilization / totalLoan) * 100;

  return (
    <>
      <div
        className="dashboard-header-container"
        style={{ backgroundImage: `url(${Mask_Dashboard})` }}
      >
        <div
          className="dashboard-header-wrapper"
          style={{ alignItems: isFinanceDetail ? null : "center" }}
        >
          <div className="header-content-container">
            <img
              src={`${tenantConfig?.logo?.content?.dark}`}
              alt="logo"
              className="header-logo"
            />
            {isFinanceDetail ? (
              <div className="header-middle-container">
                <span className="greeting-name">{welcomBackHeading}</span>
                
                <span className="loan-amount-text">{loanAmountText}</span>
                <span className="loan-label-text">{loanLabelText}</span>
              </div>
            ) : null}
            <UserInitials
              initialsClass={"header-initials-container"}
              userTextClass={"initials-text"}
              userText={usersInitials}
              onClick={onClick}
            />
          </div>
          {isProgressBar ? (
            <div className="progress-container">
              <div className="progress-bar">
                <div
                  className="progress"
                  style={{ width: `${[progressPercentage]}%` }}
                ></div>
              </div>
              <div className="progress-text-wrapper">
                <span className="progress-text">
                  {t("finance-detail.loan_utilization")}
                </span>
                <span className="progress-percent">{progressPercentage}%</span>
              </div>
            </div>
          ) : null}

          {!isFinanceDetail && <p className="header-heading">{welcomBackHeading}</p>}
         
        </div>
      </div>
    </>
  );
};

export default DashboardHeader;
